import { useTranslation } from 'react-i18next';

export function AppBootstrapLoader() {
  const { t } = useTranslation('common');
  return (
    <div role="status" aria-live="polite" className="app-bootstrap-loader">
      {t('loading')}
    </div>
  );
}
